export default __webpack_public_path__ + "static/media/noPhoto.225516e1.jpg";